import {all, fork ,call, put, takeEvery, takeLatest  } from 'redux-saga/effects'
import { push } from 'react-router-redux';
import NetworkHandler from '../net/NetworkHandler'
import StorageHandler from '../storage/StorageHandler';
import * as ACTIONS from '../containers/constants';
import { error ,success } from '../components/Alert/actions';
import {updateCities} from '../containers/Registration/RegistrationForm/actions';
const storageHandler = new StorageHandler();

export function* getCitiesSaga(){
	let cities = localStorage.getItem('cities');
	if(!cities)
	{
		const Network = new NetworkHandler();
		  try{

			  const response = yield Network.requestGetAllCities();
	  
			  if (!(response instanceof Error)) {
					yield put(updateCities(response));
					localStorage.setItem('cities', JSON.stringify(response));				  
				} else {
				  yield put(
					error({
					  message: 'Unable to cities',
					})
				  );
			  }			  
		  }catch (errorMsg) {
			  yield put(
				  error({
				   message: `Unable to load cities, please try again.${errorMsg}`,
				  })
			  );
		  }
	}
	else
	{
		
	}
  }
  
export default function* countriesSagas() { 
		yield takeLatest(ACTIONS.CRYODEX_GET_COUNTRIES, getCitiesSaga);
  }
  
  